import { render, staticRenderFns } from "./delta-edit-main.vue?vue&type=template&id=7dd3c7ac&scoped=true"
import script from "./delta-edit-main.vue?vue&type=script&lang=js"
export * from "./delta-edit-main.vue?vue&type=script&lang=js"
import style0 from "./delta-edit-main.vue?vue&type=style&index=0&id=7dd3c7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd3c7ac",
  null
  
)

export default component.exports